export * from './private-layout.component';
export * from './header/header-private.component';
export * from './footer/footer-private.component';
